import { createRouter, createWebHistory } from "vue-router"

import AccountView from "./views/AccountView.vue"
import ApiKeysView from "./views/ApiKeysView.vue"
import BillingView from "./views/BillingView.vue"
import ConnectView from "./views/ConnectView.vue"
import DeviceView from "./views/DeviceView.vue"
import LoginView from "./views/LoginView.vue"
import OverviewView from "./views/OverviewView.vue"
import PlaygroundView from "./views/PlaygroundView.vue"
import QuickstartView from "./views/QuickstartView.vue"
import UsageView from "./views/UsageView.vue"
import AdminCapabilitiesView from "./views/admin/AdminCapabilitiesView.vue"
import AdminBillingView from "./views/admin/AdminBillingView.vue"
import AdminCallsView from "./views/admin/AdminCallsView.vue"
import AdminOverviewView from "./views/admin/AdminOverviewView.vue"
import AdminProviderAccountsView from "./views/admin/AdminProviderAccountsView.vue"
import AdminUsersView from "./views/admin/AdminUsersView.vue"
import { useSessionStore } from "./stores/session"

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/login", name: "login", component: LoginView, meta: { public: true } },
    { path: "/", name: "overview", component: OverviewView },
    { path: "/connect", name: "connect", component: ConnectView },
    { path: "/api-keys", name: "api-keys", component: ApiKeysView },
    { path: "/usage", name: "usage", component: UsageView },
    { path: "/billing", name: "billing", component: BillingView },
    { path: "/device", name: "device", component: DeviceView },
    { path: "/playground", name: "playground", component: PlaygroundView },
    { path: "/quickstart", name: "quickstart", component: QuickstartView },
    { path: "/account", name: "account", component: AccountView },
    { path: "/admin", name: "admin-overview", component: AdminOverviewView, meta: { admin: true } },
    { path: "/admin/users", name: "admin-users", component: AdminUsersView, meta: { admin: true } },
    { path: "/admin/billing", name: "admin-billing", component: AdminBillingView, meta: { admin: true } },
    { path: "/admin/capabilities", name: "admin-capabilities", component: AdminCapabilitiesView, meta: { admin: true } },
    { path: "/admin/calls", name: "admin-calls", component: AdminCallsView, meta: { admin: true } },
    { path: "/admin/provider-accounts", name: "admin-provider-accounts", component: AdminProviderAccountsView, meta: { admin: true } },
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
})

router.beforeEach(async (to) => {
  const session = useSessionStore()
  await session.bootstrap()
  if (!to.meta.public && !session.authenticated) {
    return { name: "login", query: { redirect: to.fullPath } }
  }
  if (to.meta.admin && !session.isSystemAdmin) {
    return { name: "overview" }
  }
  if (to.name === "login" && session.authenticated) {
    const redirect = typeof to.query.redirect === "string" ? to.query.redirect : ""
    return redirect.startsWith("/") && !redirect.startsWith("//") ? redirect : { name: "overview" }
  }
  return true
})
